import {SliderBase} from "@share/presentation/sliders/SliderBase";
import {GoToParams} from "@share/presentation/types/GoToParams";

export class SimpleSlider extends SliderBase {
    constructor(isClickable = false, needToEmitMoved = true) {
        super(isClickable, needToEmitMoved);
    }

    dragEnd(currentOffset: number): GoToParams {
        const state = this.params.state;
        const delta = this.state.getMovingDelta();

        if (this.state.posInitial == this.state.posFinal) {
            return {};
        }
        if (this.state.posFinal >= -(this.params.totalSize - this.params.slideSize) && delta < -this.state.threshold) {
            return this.shiftSlide(1, currentOffset);
        }
        else if (this.state.posFinal <= 0 && delta > this.state.threshold) {
            return this.shiftSlide(-1, currentOffset);
        }
        else {
            return {
                offset: state?.posInitial
            }
        }
    }

    shiftSlide(direction: 1 | -1, currentOffset: number): GoToParams {
        const state = this.state;

        if (state?.allowShift && state.changeIndex(direction, this.params.slidesLength as number)) {
            state.allowShift = false;
            return {
                index: state.index
            };
        }
        else {
            state.allowShift = true;
            return {};
        }
    }

}
